// extracted by mini-css-extract-plugin
export default {"page":"StartLoading_page__HRuT5","nav":"StartLoading_nav__G-ewq","wordmark":"StartLoading_wordmark__SfgjE"};